import {deepCopyObject} from "@/global/modules/functions.js";

export default {
    data(){
        return{
            custom_styles: {},
            custom_css_styles: [],
            all_screen_styles: {},
            canvas_width_timeout: null
        }
    },
    methods: {
        setCustomCssStyles(custom_styles){
            if(typeof custom_styles !== 'undefined'){
                this.custom_css_styles = custom_styles;
           
                this.matchMediaQueryInContainer();
            }
        },
        matchMediaQueryOnLoad(current_width){
            this.custom_styles = {};
            this.setAllScreenSizeStyles();
     
             for (let i = 0; i < this.custom_css_styles.length; i++) {
                
                if(this.custom_css_styles[i].screen_size != 'All'){
                    let current_media_query = this.custom_css_styles[i];
                    let min_screen_size = current_media_query.min_screen_size.split('px')[0];
                    let max_screen_size = current_media_query.max_screen_size.split('px')[0];
    
                    if(current_width >= min_screen_size && current_width <= max_screen_size){
                        this.setCustomStyle(current_media_query);
                    }
                }
            }
        },
        setCustomStyle(obj){
            let style = {};
            style[obj.property] = obj.value;

            // this.custom_styles = {...deepCopyObject(this.custom_styles), ...style};

            if(typeof this.custom_styles[obj.group_by] === 'undefined'){
                this.custom_styles[obj.group_by] = {};
            }

            this.custom_styles[obj.group_by] = {...deepCopyObject(this.custom_styles[obj.group_by]), ...style};
            return style;
        },
        setAllScreenSizeStyles(){
            let all_screens = this.custom_css_styles.filter(x=>x.min_screen_size == '' && x.max_screen_size == '');

            for (let i = 0; i < all_screens.length; i++) {
                let current_style = this.setCustomStyle(all_screens[i]);
                this.all_screen_styles = {...deepCopyObject(this.all_screen_styles), ...current_style};
            }
        },
        matchCanvas(canvas_width){
            clearTimeout(this.canvas_width_timeout);

            this.canvas_width_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error 
                this.matchMediaQueryOnLoad(canvas_width);
            }, 1);
            
        },
        matchMediaQueryInContainer(){
            let canvas = document.getElementsByClassName('canvas-container')[0];
            if(typeof canvas !== 'undefined'){
                new ResizeObserver(()=>{
                    this.matchCanvas(canvas.clientWidth);
                }).observe(canvas);
            }
        }
    }
 }